var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("Les lieux de rencontre")]),_c('b-row',_vm._l((_vm.locations),function(location){return _c('b-col',{key:location.id,staticClass:"text-center"},[_c('Location',{attrs:{"location":location}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }